// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.description-text {
  resize: none;
  border: none Transparent;
  outline: none;
  height: 50px;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  width: 100%;
}

.detail-form {
  height: 100%;
}

.remove-button {
  margin-left: 10px;
}

.bottom-spacer {
  margin-bottom: 10px;
}

.text-success {
  color: #a3cfbb !important;
  font-size: 12px !important;
}

.disclaimerView {
  font-size: 13px;
  height: auto;
  overflow-y: scroll;
  padding: 5px;
  border: 1px solid rgb(102, 102, 102);
  border-radius: 6px;
  background: rgba(238, 238, 238, 0.98);
  text-align: justify;
}

.tp-limit-full-width-dropdown {
  width: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
